import React from "react";
import FileUpload from "./FileUpload";
import "./AvatarUpload.less";

interface AvatarUploadProps {
  value?: AppAPI.FileInfo;
  onChange?: (fileInfo: AppAPI.FileInfo | undefined) => void;
  disabled?: boolean;
}

/**
 * 头像上传组件
 * 基于通用FileUpload组件实现
 */
const AvatarUpload: React.FC<AvatarUploadProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const config = {
    maxSize: 2, // 2MB
    allowedTypes: ["image/jpeg", "image/png"],
    accept: "image/jpeg,image/png",
    listType: "picture-card" as const,
    uploadText: "上传头像",
    helpText: "支持 JPG、PNG 格式，文件大小不超过 2MB",
    showPreview: true,
  };

  return (
    <div>
      <div style={{ marginBottom: 8, fontWeight: 500 }}>头像</div>
      <FileUpload
        value={value}
        onChange={onChange}
        disabled={disabled}
        config={config}
      />
    </div>
  );
};

export default AvatarUpload;
